module.exports = __webpack_public_path__ + "img/yyjjfa_02.73c2a414.jpg";